import React from 'react';

import { cleanString } from '../../util/renderHelper';

import { Col, Row } from 'antd';

const ProviderTypeToggle = ({ provider, clickAction }) => (
  <Row className="fixed provider-type-toggle">
    <Col xs={{ span: 22, offset: 1 }} lg={{ span: 24, offset: 0 }}>
      <div className="provider-type-toggle__label">Information for</div>
      <button className="provider-type-toggle__button" onClick={clickAction}>
        <span className="provider-type-toggle__value">
          {provider ? cleanString(provider.name) : ''}
        </span>
        <span className="provider-type-toggle__pill">Change</span>
      </button>
    </Col>
  </Row>
);

export default ProviderTypeToggle;
